import { ACCOUNTS, BASE_URL, BULK_UPDATE_CREATE, COST_CATEGORIES_MAPPING, COUNTRIES, EXPORT, FILTERS, IKA_MAPPING, INPUT_FORMS, MFA, USERS } from "../../constant/apiEndpoints";
import * as constants from "../../pages/MappingFile/IKAMap/constants";
import { ICostCategoriesMap, ICostCategoriesMapForSave, IIKAMap, IIKAMapForSave, IIKAMapFromTable, ISelectedFilters, ICostCategoriesMapFromTable } from "../../reducer/mappingFiles/_interfaces";
import { SET_COST_CATEGORIES_DATA, SET_IKA_ERROR, SET_IKA_MAP_COUNTRIES, SET_IKA_MAP_COUNTRIES_LOADING, SET_IKA_MAP_DATA, SET_COST_CATEGORIES_DATA_LOADING, SET_INPUT_SUGGESTIONS } from "../../reducer/mappingFiles/constants"
import { IAPIReturn } from "../../services/_interfaces";
import APIService from "../../services/APIService";

export const setCostCategoriesMapData = (payload:ICostCategoriesMap[]) => ({ type: SET_COST_CATEGORIES_DATA, payload })
export const setError = (payload:string) => ({ type: SET_IKA_ERROR, payload })

export const loadCountries = (formId:string) => async (dispatch:any) => {
    dispatch({ type: SET_IKA_MAP_COUNTRIES_LOADING, payload: true });

    const url = BASE_URL + ACCOUNTS + USERS + COUNTRIES + `?form_id=${formId}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in user countrylist API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_COUNTRIES_LOADING, payload: false });
    } else {
        const transformedData = response.results.map(({ id, title }:{id:string, title:string}) => ({
            label: title,
            value: id,
            id,
            title
        }));
        dispatch({type: SET_IKA_MAP_COUNTRIES, payload: transformedData});
    }
}

export const loadData = (filters:ISelectedFilters, selected_form:string) => async (dispatch:any) => {
    dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: true });
    
    const url = BASE_URL + INPUT_FORMS + MFA + COST_CATEGORIES_MAPPING
        + `?selected_form=${selected_form}`;
    const response:IAPIReturn = await new APIService().get(url);
    debugger;
    if (response.error) {
        console.log("error in COST_CATEGORIES_MAPPING API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: false });
    } else {
        dispatch(setCostCategoriesMapData(response.results));
    }
}

export const deleteItems = (comment:string, ids:number[], selected_form:string, filters:ISelectedFilters) => async (dispatch:any) => {
    dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: true });
    
    const url = BASE_URL + INPUT_FORMS + MFA + COST_CATEGORIES_MAPPING;
    const response:IAPIReturn = await new APIService().delete(url, {comment, ids, selected_form});

    if (response.error) {
        console.log("error in COST_CATEGORIES_MAPPING API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: false });
    } else {
        dispatch(loadData(filters, selected_form));
    }
}

export const saveItem = (item:ICostCategoriesMapForSave, selected_form:string) => async (dispatch:any) => {
    dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: true });
    console.log(item);
    
    const url = BASE_URL + INPUT_FORMS + MFA + COST_CATEGORIES_MAPPING + `?selected_form=${selected_form}`;
    let response:IAPIReturn;
    if (item.id) {
        response = await new APIService().put(url, { item, selected_form });
    } else {
        response = await new APIService().post(url, { item, selected_form });

    }
    
    if (response.error) {
        console.log("error in Cost Categories Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: false });
    } else {
        dispatch(loadData(constants.INITIAL_FILTERS, selected_form));
    }
}

export const massUpload = async (data:ICostCategoriesMapFromTable[], selected_form:string) => {
    const dataMap = data.map((item) => ({
        mix: item['Mix'],
        ce_group_level_1: item['CE Group Level 1'],
        ce_group_level_2: item['CE Group Level 2'],
        ce_group_level_3: item['CE Group Level 3'],
        gl_account: item['GL Account'],
        gl_account_description: item['GL Account Description'],
    }))

    const url = BASE_URL + INPUT_FORMS + MFA + COST_CATEGORIES_MAPPING + BULK_UPDATE_CREATE + `?selected_form=${selected_form}`;
    try {
        const response:IAPIReturn = await new APIService().post(url, { data: dataMap, selected_form });
        return response;
    } catch (error) {
        throw new Error('Error') 
    }

}

export const exportData = () => async (dispatch:any) => {
    const url = BASE_URL + INPUT_FORMS + MFA + COST_CATEGORIES_MAPPING + EXPORT + `?selected_form=formmap`

    fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token') || '').access}`,
            })
        }).then(response =>
            response.blob().then(blob => {
                const today = new Date()
                const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "cost_categories_mapping_" + date + "_" + time + ".csv";
                a.click();
            })
        );
}

export const getFilters = (selected_form:string) => async (dispatch:any) => {
    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING + FILTERS + `?selected_form=${selected_form}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in IKA Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: false });
    } else {
        dispatch({type: SET_INPUT_SUGGESTIONS, payload: response.results});
    }
}